import { createFileRoute, Link } from "../lib/router-compat";
import { PageShell } from "../components/PageShell";

export const Route = createFileRoute("/pan-festival")({
  head: () => ({
    meta: [
      { title: "Pan New England Festival — The Pan Institute" },
      {
        name: "description",
        content:
          "32nd Annual Pan New England Festival — May 3 and 4, 2025, Mill Park, Augusta, Maine. Open to the public with a suggested donation.",
      },
      { property: "og:title", content: "Pan New England Festival" },
      {
        property: "og:description",
        content: "Annual Pan New England Festival in Augusta, Maine.",
      },
    ],
  }),
  component: FestivalPage,
});

const POSTER_URL =
  "https://img1.wsimg.com/blobby/go/cc067f05-785a-4de6-a400-eaada90fa319/32nd%20Pan%20Festival%20Poster%20(2).pdf";

const FACTS = [
  { k: "May 3 & 4", v: "2025" },
  { k: "Mill Park", v: "Augusta, Maine" },
  { k: "$10", v: "Suggested donation" },
];

function FestivalPage() {
  return (
    <PageShell
      tag=""
      title={
        <>
          Pan New England <span className="text-primary">Festival</span>.
        </>
      }
      intro="The 32nd Annual Pan New England Festival — May 3rd and 4th, 2025 at Mill Park in Augusta, Maine. Open to the public."
    >
      {/* Editorial hero card */}
      <div className="relative overflow-hidden rounded-3xl border border-border/40 bg-card/30 backdrop-blur-sm p-8 md:p-12">
        <div
          className="absolute -top-24 -right-24 h-72 w-72 rounded-full bg-[radial-gradient(circle_at_center,color-mix(in_oklab,var(--copper)_18%,transparent),transparent_70%)] blur-3xl"
          aria-hidden
        />
        <div className="relative grid md:grid-cols-[1fr_auto] gap-8 items-end">
          <div>
            <div className="text-[10px] uppercase tracking-[0.5em] text-primary">
              32nd Annual · Open to the public
            </div>
            <h2 className="mt-4 font-display italic text-3xl md:text-5xl leading-[1.05]">
              Pan New England<br />Festival 2025
            </h2>
            <p className="mt-5 text-sm text-foreground/70 max-w-md leading-relaxed">
              Mill Park, Augusta, Maine — May 3rd & 4th, 2025.
              Suggested $10 donation at the gate.
            </p>
          </div>
          <div className="flex flex-wrap gap-3">
            <a
              href={POSTER_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center px-6 py-3 bg-primary text-primary-foreground text-[11px] tracking-[0.3em] uppercase rounded-full hover:opacity-90 transition shadow-lg shadow-primary/10"
            >
              View poster
            </a>
            <a
              href={POSTER_URL}
              download
              className="inline-flex items-center justify-center px-6 py-3 border border-border/60 text-[11px] tracking-[0.3em] uppercase rounded-full hover:border-primary/60 hover:text-primary transition"
            >
              Download
            </a>
          </div>
        </div>
      </div>

      {/* Facts strip */}
      <dl className="mt-10 grid grid-cols-3 divide-x divide-border/40 rounded-2xl border border-border/40 bg-card/30">
        {FACTS.map((s) => (
          <div key={s.v} className="px-2 sm:px-4 py-6 text-center min-w-0">
            <dt className="font-display italic text-2xl sm:text-3xl md:text-4xl text-primary leading-none break-words">
              {s.k}
            </dt>
            <dd className="mt-2 text-[9px] sm:text-[10px] uppercase tracking-[0.2em] sm:tracking-[0.35em] text-foreground/55 break-words">
              {s.v}
            </dd>
          </div>
        ))}
      </dl>

      {/* Poster preview */}
      <div className="mt-16">
        <div className="flex items-end justify-between gap-6 mb-6 border-b border-border/40 pb-5">
          <div>
            <div className="text-[10px] uppercase tracking-[0.5em] text-primary/80">
              The poster
            </div>
            <h2 className="mt-3 font-display italic text-3xl md:text-4xl">
              Schedule & lineup
            </h2>
          </div>
          <a
            href={POSTER_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="hidden md:inline text-[10px] uppercase tracking-[0.35em] text-primary hover:underline whitespace-nowrap"
          >
            Open in new tab →
          </a>
        </div>
        <div className="overflow-hidden rounded-2xl border border-border/40 bg-card/30 aspect-[4/5] md:aspect-[16/10] shadow-2xl shadow-black/10">
          <iframe
            src={`${POSTER_URL}#view=FitH`}
            title="32nd Annual Pan New England Festival Poster"
            className="w-full h-full"
          />
        </div>
      </div>

      {/* CTA */}
      <div className="mt-20 rounded-3xl border border-border/40 bg-gradient-to-br from-primary/10 via-transparent to-transparent p-8 md:p-12">
        <div className="grid md:grid-cols-12 gap-6 items-center">
          <div className="md:col-span-8">
            <div className="text-[10px] uppercase tracking-[0.5em] text-primary/80">
              Be part of it
            </div>
            <h2 className="mt-3 font-display italic text-3xl md:text-4xl leading-[1.05]">
              Mark your calendar — or get in touch.
            </h2>
          </div>
          <div className="md:col-span-4 flex flex-wrap gap-3 md:justify-end">
            <Link
              to="/calendar"
              className="inline-flex items-center justify-center px-6 py-3 bg-primary text-primary-foreground text-[11px] tracking-[0.3em] uppercase rounded-full hover:opacity-90 transition shadow-lg shadow-primary/10 whitespace-nowrap"
            >
              See dates
            </Link>
            <Link
              to="/contact"
              className="inline-flex items-center justify-center px-6 py-3 border border-border/60 text-[11px] tracking-[0.3em] uppercase rounded-full hover:border-primary/60 hover:text-primary transition whitespace-nowrap"
            >
              Get in touch
            </Link>
          </div>
        </div>
      </div>
    </PageShell>
  );
}
